(function () {
  function initCard(card) {
    if (card.dataset.hs) return;
    var wrap = card.querySelector('.product-item__image');
    var thumbs = card.querySelectorAll('.product-item__thumb img');
    if (!wrap || thumbs.length < 2) return;
    card.dataset.hs = '1';

        var srcs = [].map.call(thumbs, function (t) {
      var u = t.currentSrc || t.src;
      if (u.indexOf('width=') > -1) return u.replace(/width=\d+/, 'width=800');
      return u.replace(/(_\d+x\d*)?(\.(jpg|jpeg|png|webp))/i, '_800x$2');
    });

    // our own overlay image — sits above the theme's, full control
    var ov = document.createElement('img');
    ov.className = 'pcard-overlay';
    ov.alt = '';
    ov.src = srcs[0];
    wrap.appendChild(ov);

    // preload the rest so the sweep is instant
    srcs.forEach(function (s) { var p = new Image(); p.src = s; });

    var pag = document.createElement('div');
    pag.className = 'pcard-pagination';
    srcs.forEach(function () {
      pag.appendChild(document.createElement('span')).className = 'pcard-pagination__seg';
    });
    wrap.appendChild(pag);
    var segs = pag.children;

    function show(i) {
      ov.src = srcs[i];
      for (var k = 0; k < segs.length; k++) segs[k].classList.toggle('is-active', k === i);
    }

        wrap.addEventListener('mousemove', function (e) {
      var r = wrap.getBoundingClientRect();
      var i = Math.min(srcs.length - 1, Math.max(0, Math.floor((e.clientX - r.left) / r.width * srcs.length)));
      show(i);
    }, true);
    wrap.addEventListener('mouseenter', function () {
      ov.classList.add('is-on');
    }, true);
    wrap.addEventListener('mouseleave', function () {
      ov.classList.remove('is-on');
      show(0);
    }, true);

    segs[0].classList.add('is-active');
  }

    function initAll() { document.querySelectorAll('.product-item').forEach(initCard); }

  // slider sections rebuild DOM after init — rebind those cards
  window.addEventListener('load', function () {
    setTimeout(function () {
            document.querySelectorAll('css-slider .product-item').forEach(function (card) {
        delete card.dataset.hs;
        card.querySelectorAll('.pcard-overlay, .pcard-pagination').forEach(function (n) { n.remove(); });
        initCard(card);
      });
    }, 800);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();

// Gallery full-bleed left
function setGalleryBleed() {
  var g = document.querySelector('.main-product .product-gallery');
  if (!g) return;
  if (window.innerWidth < 1024) { g.style.setProperty('--gallery-bleed', '0px'); return; }
  g.style.setProperty('--gallery-bleed', '0px');
  var left = g.getBoundingClientRect().left;
  g.style.setProperty('--gallery-bleed', left + 'px');
}
window.addEventListener('load', setGalleryBleed);
window.addEventListener('resize', setGalleryBleed);

// Hide single-product families from the Collection filter
(function () {
  var hideFams = ['Allendale','Ashford','Bellevue','Belmont','Blackstone','Brooks','Charleston','Chatham','Freemont','Grant','Irvine','Onyx','Palmer','Prescott','Richmond','Webster','Wentworth','Westmont','Woodhaven'];
  function prune() {
    document.querySelectorAll('.facets__form label, .facets__form li, .facets__form .facet-checkbox').forEach(function (el) {
      var t = el.textContent.trim().split('(')[0].trim();
      if (hideFams.indexOf(t) > -1) {
        var item = el.closest('li') || el;
        item.style.display = 'none';
      }
    });
  }
  prune();
  new MutationObserver(prune).observe(document.body, { childList: true, subtree: true });
})();